<mat-card class="mat-elevation-z8">
  <mat-card-content>
    @if (loading()) {
      <div style="display:flex; justify-content:center; padding: 32px;">
        <mat-spinner diameter="36"/>
      </div>
    } @else if (error()) {
      <p class="error-link">{{ error() }}</p>
    } @else if (timeline()) {
      <div class="timeline-summary">
        <span>Created: {{ timeline()!.dateCreated | date:'M/dd/yyyy HH:mm' }}</span>
        <span>Booked: {{ timeline()!.bookedDate | date:'M/dd/yyyy' }}</span>
        <span>Status: {{ timeline()!.isCancelled ? 'Cancelled' : 'Active' }}</span>
        <span>Sent to ERP: {{ timeline()!.queueRowCount }} time(s)</span>
        <span>Initial: {{ timeline()!.initialRowCount }}</span>
        <span>Delta: {{ timeline()!.deltaRowCount }}</span>
      </div>

      <mat-tab-group>
        <mat-tab label="What Changed">
          @if (!enrichedChangeLog().length) {
            <p style="padding: 12px 0;">No changes recorded for this trip.</p>
          }
          <p class="hint-note">
            "Enqueued?" shows whether this <em>item</em> has ever been sent to ERP, and its most
            recent status — not necessarily whether this specific edit was the one included in
            that send. An item edited more than once may show a status from a later change.
          </p>
          <div class="timeline-table-wrap">
            <table class="timeline">
              <thead>
                <tr>
                  <th>Changed</th>
                  <th>Item</th>
                  <th>Field</th>
                  <th>Old Value</th>
                  <th>New Value</th>
                  <th>Changed By</th>
                  <th matTooltip="Whether this item has ever been sent to ERP, and its most recent status — see note above the table">Enqueued?</th>
                  <th>Last Sent to ERP</th>
                  <th>ERP Result</th>
                </tr>
              </thead>
              <tbody>
                @for (row of enrichedChangeLog(); track row.id) {
                  <tr>
                    <td>{{ toTorontoDate(row.changedAtUtc) | date:'M/dd/yyyy HH:mm':'America/Toronto' }}</td>
                    <td>{{ entityDisplay(row) }}</td>
                    <td>{{ humanizeFieldName(row.fieldName) }}</td>
                    <td>{{ row.oldValue }}</td>
                    <td>{{ row.newValue }}</td>
                    <td>{{ row.userUpdated }}</td>
                    <td [class]="statusClass(row.matchedEvent)">{{ statusLabel(row.matchedEvent) }}</td>
                    <td>{{ row.matchedEvent?.erpMessageTimestamp ? (row.matchedEvent!.erpMessageTimestamp | date:'M/dd/yyyy HH:mm') : '' }}</td>
                    <td>
                      @if (row.matchedEvent) {
                        {{ latestResult(row.matchedEvent) }}
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </mat-tab>

        <mat-tab label="ERP Sync Timeline">
          @if (!timeline()!.events.length) {
            <p style="padding: 12px 0;">No sync-queue rows for this sales order.</p>
          }
          <div class="timeline-table-wrap">
            <table class="timeline">
              <thead>
                <tr>
                  <th>Queued</th>
                  <th>Type</th>
                  <th>Entity</th>
                  <th>What</th>
                  <th>Detail</th>
                  <th>Status</th>
                  <th>Sent</th>
                  <th>ERP Order #</th>
                  <th>Result</th>
                  <th>Error</th>
                </tr>
              </thead>
              <tbody>
                @for (event of timeline()!.events; track event.syncQueueId) {
                  <tr>
                    <td>{{ event.dateQueued | date:'M/dd/yyyy HH:mm' }}</td>
                    <td>{{ event.changeType }}</td>
                    <td>{{ event.changedEntityType }}</td>
                    <td>{{ event.entityLabel }}</td>
                    <td>{{ event.entityDetail }}</td>
                    <td [class]="statusClass(event)">{{ statusLabel(event) }}</td>
                    <td>{{ event.erpMessageTimestamp | date:'M/dd/yyyy HH:mm' }}</td>
                    <td>{{ latestOrder(event) }}</td>
                    <td>{{ latestResult(event) }}</td>
                    <td>
                      @if (event.errorMessage) {
                        <span class="error-link" (click)="openError('Queue error', event.errorMessage)">Queue</span>
                      }
                      @for (response of event.responses; track response.erpResponseId) {
                        @if (response.errorDescription) {
                          <div class="error-link" (click)="openError('ERP error', response.errorDescription)">ERP</div>
                        }
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </mat-tab>
      </mat-tab-group>
    }
  </mat-card-content>
</mat-card>
